import TableCellLink from "ds/components/Table/Row/CellLink";
import TableCellText from "ds/components/Table/Row/CellText";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import useTypedContext from "hooks/useTypedContext";
import { getCommitLabel } from "utils/commit";
import { providerHasVcsHost } from "utils/vcs";
import { VersionContext } from "views/Account/Module/Version/Context";

import { ModuleVersionTestCaseRow } from "../types";

const ModuleVersionTestCasesTableCommitCell = ({
  item: testCase,
  ...cellProps
}: TableSimpleCellProps<ModuleVersionTestCaseRow>) => {
  const { module } = useTypedContext(VersionContext);

  const hasVcsHost = providerHasVcsHost(module.provider);
  const commitLabel = getCommitLabel(module.provider, testCase.commit.hash);

  return (
    <TableSimpleCell {...cellProps}>
      {hasVcsHost && (
        <TableCellLink href={testCase.commit.url} target="_blank">
          {commitLabel}
        </TableCellLink>
      )}
      {!hasVcsHost && <TableCellText>{commitLabel}</TableCellText>}
    </TableSimpleCell>
  );
};

export default ModuleVersionTestCasesTableCommitCell;
